export const getMixpanelToken = () => process.env.VITE_MIXPANEL_TOKEN;
